import pakaiClass from 'pakai-class'
import React, { useRef } from 'react'
import { Link } from 'react-router-dom'
import Ripple from '../Ripple'
import styles from './button.module.scss'

const Button = ({
  children,
  className,
  href,
  onClick,
  variant = 'primary',
  size = 'medium',
  loading = false,
  disabled = false,
  icon,
  ...props
}) => {
  const rippleRef = useRef()
  const ActionTag = href ? Link : 'button';

  const addRipple = (e) => {
    if (rippleRef.current && !loading && !disabled) rippleRef.current.addRipple(e)
    if (typeof onClick === 'function' && !loading && !disabled) onClick(e)
  }

  return (
    <ActionTag
      {...props}
      className={pakaiClass(
        styles.buttonRoot,
        styles[variant],
        styles[size],
        loading && styles.loading,
        disabled && styles.disabled,
        className
      )}
      onClick={addRipple}
      to={href}
      disabled={disabled || loading}
    >
      <div className={styles.buttonContent}>
        {loading && (
          <div className={styles.spinner}></div>
        )}
        {icon && !loading && (
          <span className={styles.icon}>{icon}</span>
        )}
        <span className={styles.text}>{children}</span>
      </div>
      <Ripple ref={rippleRef} />
    </ActionTag>
  )
}

export default Button
